import { render, staticRenderFns } from "./OptimizationControlWidget.vue?vue&type=template&id=095880d2&scoped=true&"
import script from "./OptimizationControlWidget.vue?vue&type=script&lang=js&"
export * from "./OptimizationControlWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095880d2",
  null
  
)

export default component.exports